import React, { Component } from "react";
import { connect } from "react-redux";
import { openConfirmDialogComp } from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";

const styles = theme => ({});

const GreenCheckbox = withStyles({
  root: {
    marginRight: 0,
    color: green[400],
    "&$checked": {
      color: green[600]
    }
  },
  checked: {}
})(props => <Checkbox color="default" {...props} />);

class ConfirmDialog extends Component {
  constructor(props){
    super(props)

    this.state = {
      open: false,
      checkboxDA: false,
      checkboxNoMixed: false,
      btnConfirm: false,
    };
  }

  handleClickOpen = () => {
    this.setState({
      open: true
    }, () => {
      this.props.openConfirmDialogComp(true);
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
      checkboxDA: false,
      checkboxNoMixed: false,
    }, () => {
      this.props.openConfirmDialogComp(false);
    });
  };

  handleConfirm = () => {
    this.props.handleConfirmRemoveDA()
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.checked
    }, () => {

      if(this.props.bankItem){
        if(this.state.checkboxDA && this.state.checkboxNoMixed){
          this.setState({ btnConfirm: true })
        } else {
          this.setState({ btnConfirm: false })
        }
      } else {
        if(this.state.checkboxDA){
          this.setState({ btnConfirm: true })
        } else {
          this.setState({ btnConfirm: false })
        }
      }

    });

  };

  render() {
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={this.props.openConfirmDialogValue}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {"Você deseja confirmar o descadastramento deste débito?"}
          </DialogTitle>

          <DialogContent>
            <FormControlLabel
            style={{'marginRight': '0'}}
              control={
                <GreenCheckbox
                  checked={this.state.checkboxDA}
                  onChange={this.handleChange("checkboxDA")}
                  value="checkboxDA"
                />
              }
            />
            <strong>CANCELAMENTO DE DÉBITO EM CONTA </strong>
            <DialogContentText>
              Solicita o cancelamento do serviço de débito automático referente
              aos tributos relacionados.
            </DialogContentText>
            <DialogContentText>
              Da mesma forma, reconhece que, os motivos operacionais, os débitos
              com data de pagamento para os próximos dois dias poderão ainda ser
              processados pela sistemática de débito automático.
            </DialogContentText>

            {this.props.bankItem && (
              <div>
                <FormControlLabel
                style={{'marginRight': '0'}}
                  control={
                    <GreenCheckbox
                      checked={this.state.checkboxNoMixed}
                      onChange={this.handleChange("checkboxNoMixed")}
                      value="checkboxNoMixed"
                    />
                  }
                />
                <strong>
                  INSTRUÇÕES PARA CANCELAMENTO DO DÉBITO EM CONTA PARA O BANCO
                  SELECIONADO
                </strong>
                <DialogContentText>
                  <p>
                    1. Aperte o botão "Prosseguir >>" para imprimir o código de
                    identificação para o débito automático. <br />
                    2. Compareça a sua agência portando identidade, CPF e o
                    código de identificação gerado. <br />
                    3. No caso de alteração dos dados bancários o cancelamento
                    do serviço, procure o seu gerente.
                  </p>
                </DialogContentText>
              </div>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancelar
            </Button>
            <Button onClick={this.handleConfirm} disabled={!this.state.btnConfirm} color="primary" autoFocus>
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

// export default ConfirmDialog
const mapStateToProps = store => ({
  openConfirmDialogValue: store.cardDebitState.openConfirmDialogValue
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ openConfirmDialogComp }, dispatch);

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConfirmDialog)
);
